import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';

import { addFileToUpload, addFilesToUpload, setCancelUpload } from '../../uploadController/actions/uploadController-actions';

class FileUploadDrop extends Component {
	constructor(props) {
		super(props);

		this.state = {
			files: new Set(),
			filePreviews: new Set(),
			fileQueue: new Set(),
			file: '',
			imagePreviewUrl: '',
            fileInputRefClicked:false
		};

		this.onDrop = this.onDrop.bind(this);
		this.addFiles = this.addFiles.bind(this);
		this.uploadFile = this.uploadFile.bind(this);
		this.uploadFiles = this.uploadFiles.bind(this);
		this.setFileInputRef = this.setFileInputRef.bind(this);
		this.handleFilesSelected = this.handleFilesSelected.bind(this);
		this.openFileDialog = this.openFileDialog.bind(this);
	}

	componentDidUpdate() {
		if (this.state.fileQueue.size && this.props.albumId !== -1) {
			[...this.state.fileQueue.values()].forEach(file => {
				this.uploadFile(file);
			});
			this.setState({ fileQueue: new Set() });
		}
	}
	componentWillReceiveProps(nextProps){
		if(nextProps.albumId > 0 && nextProps.disabled == false && this.state.fileInputRefClicked){
			this.setState({fileInputRefClicked:false})
            //setTimeout(() => this.openFileDialog(), 500);
		}
	}
	addFiles(files) {
		files.forEach(file => {
			this.uploadFile(file);
		});
	}

	uploadFile(file) {
		const { upload } = this.props;
		//console.log(file);
	upload(file);
	}


	uploadFiles(files) {
		const { uploads } = this.props;
		//console.log(file);
	uploads(files);
	}
	onDrop(event){
		event.preventDefault()
		event.stopPropagation()
		if(this.props.disabled){
			if(this.props.onAlbumNotSelected){
				this.props.onAlbumNotSelected();
			}
		}else{
            var items = typeof(event.dataTransfer.items) === "undefined"?event.dataTransfer.files:event.dataTransfer.items;
            for (var i=0; i<items.length; i++) {
                // webkitGetAsEntry is where the magic happens
                var item = null;

                if(typeof(items[i].webkitGetAsEntry) === "function"){
                	item = items[i].webkitGetAsEntry();
				}else if(typeof(items[i].getAsEntry) === "function"){
                	item = items[i].getAsEntry();
				}else if(typeof(items[i].getAsFile) === "function"){
                	item = items[i].getAsFile();
				}else{
                	//IE11 path
                	item = items[i];
                    this.uploadFile(item);
                    return;
				}
                if (item) {
                    traverseFileTree(item,"", this.uploadFile);
                }
            }
		}
	}
    setFileInputRef(val){
		this.fileInputRef = val;
	}
    openFileDialog(val){
		if(this.props.disabled){
			this.setState({fileInputRefClicked: true})
            if(this.props.onAlbumNotSelected){
                this.props.onAlbumNotSelected();
            }
		}else {
            this.fileInputRef.click();
        }
	}
	handleFilesSelected(event){
		if(this.props.disabled){
			if(this.props.onAlbumNotSelected){
				this.props.onAlbumNotSelected();
			}
		}else {
            for (var i = 0; i < event.target.files.length; i++) {
                this.uploadFile(event.target.files[i])
            }
        }
	}

	// onDrop(acceptedFiles /*,rejectedFiles*/) {
	// 		if (this.props.disabled) {
	// 		//const newFileQueue = new Set(acceptedFiles);
	// 		//this.setState({ fileQueue: newFileQueue });
    //
	// 		if (this.props.onAlbumNotSelected) {
	// 			this.props.onAlbumNotSelected();
	// 		}
	// 	} else {
	// 		this.props.setCancelUpload(false);
	// 		this.uploadFiles(acceptedFiles);
	// 	}
	// }

	render() {
		return (
			<div className="drop-container">
				<div className="drop-container-top-dash" />
				<div className="drop-container-bottom-dash" />
				<div className="drop-container-left-dash" />
				<div className="drop-container-right-dash" />
				<div className="drop-container-top-left" />
				<div className="drop-container-top-right" />
				<div className="drop-container-bottom-left" />
				<div className="drop-container-bottom-right" />

				<div className="drop-inner">
					{/*<Dropzone className="drop-target" onDrop={this.onDrop} disablePreview={false} />*/}
					<div className="drop-target"
						 onDrop={(event) => {
						 	this.onDrop(event);
                         }}
                         onDragOver={(e) => {
                             e.stopPropagation();
                             e.preventDefault();
                             // e.dataTransfer.dropEffect = 'copy'; //IE11 bug - this does not work
                         }
                         }
						 onClick={this.openFileDialog}
					/>
					<input type="file" multiple={true} style={{display:"none"}} ref={this.setFileInputRef} onChange={this.handleFilesSelected}/>
					<div className="icon-cloud" />
				</div>
			</div>
		);
	}
}

FileUploadDrop.propTypes = {
	disabled: PropTypes.bool,
	onAlbumNotSelected: PropTypes.func,
	upload: PropTypes.func,
	uploads: PropTypes.func,
	albumId: PropTypes.number,
	setCancelUpload: PropTypes.func
};

let selectionCounter = 0;
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		upload: file => {
			
			file.dropTime = parseFloat(`${Date.now()}.${selectionCounter++}`);
			file.waiting = false;
			file.ccId = ownProps.selectedAlbumId;
			dispatch(addFileToUpload(file));
		},
		uploads: (files) => {
			
			
			dispatch(addFilesToUpload(files, ownProps.selectedAlbumId));
		},

		setCancelUpload: (status) => {
			
			
			dispatch(setCancelUpload(status));
		}
	};
};

export default connect(null, mapDispatchToProps)(FileUploadDrop);


const traverseFileTree = (item, path, uploadFile) => {
    path = path || "";
    if (item.isFile) {
        // Get file
        item.file(function(file) {
            uploadFile(file);
            // console.log("File:", path + file.name);
        });
    } else if (item.isDirectory) {
        // Get folder contents
        var dirReader = item.createReader();
        dirReader.readEntries(function(entries) {
            for (var i=0; i<entries.length; i++) {
                traverseFileTree(entries[i], path + item.name + "/", uploadFile);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/upload/components/file-upload-drop.jsx